import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {
  constructor() { }
   encryptSecretKey = "123456$#@$^@1ERF";
 // The set method is use for encrypt the value.
  set(keys, value) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    return encrypted.toString();
  }

  //The get method is use for decrypt the value.
  get(keys, value) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }


  //encryptData(keys,msg) {
  //  //var keySize = 256;
  //  //var salt = CryptoJS.lib.WordArray.random(16);
  //  //var key = CryptoJS.PBKDF2(this.encryptSecretKey, salt, {
  //  //  keySize: keySize / 32,
  //  //  iterations: 100
  //  var key = CryptoJS.enc.Utf8.parse(keys);
  //  var iv = CryptoJS.enc.Utf8.parse(keys);
  //  var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(msg.toString()), key,
  //    {
  //      keySize: 128 / 8,
  //      iv: iv,
  //      mode: CryptoJS.mode.CBC,
  //      padding: CryptoJS.pad.Pkcs7
  //    });
  //  return encrypted.toString();
  //  //var iv = CryptoJS.lib.WordArray.random(128 / 8);

  //  //var encrypted = CryptoJS.AES.encrypt(msg, key, {
  //  //  iv: iv,
  //  //  padding: CryptoJS.pad.Pkcs7,
  //  //  mode: CryptoJS.mode.CBC
  //  //});

  //  //var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
  //  //return result;
  //}
  decrypt(key, ciphertextB64) {

     key = CryptoJS.enc.Utf8.parse(key);
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);

    var decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, { iv: iv });
    var decryptedId = decrypted.toString(CryptoJS.enc.Utf8);
    if (decryptedId == null || decryptedId == "") {
      decryptedId = this.get(this.encryptSecretKey, ciphertextB64)
    }
    return decryptedId;
  } 
}
